import type { RouterConfig } from '@nuxt/schema'
import { sortRoutes } from '~/composables/util'

const routeParamOptions = {
  departmentTypeSlug: ['dierenambulance', 'dierenasiel', 'extern', 'hondenschool', 'wildopvang'],
  mdizCategory: ['gevonden-dieren', 'vermiste-dieren'],
}

export default {
  routes: (routes) => {
    let hostname: string
    const { ssrContext } = useNuxtApp()
    if (import.meta.server && ssrContext && ssrContext.event.node.req) {
      const req = ssrContext.event.node.req
      hostname = req.headers.host
    } else if (import.meta.client) {
      hostname = window.location.host
    }

    let keyword = 'www'
    let domain = 'default'
    let site = 'default'
    let style = 'db'
    if (/^([ap]-)?ikzoekbaas[.]/i.test(hostname)) {
      keyword = 'ikzoekbaas'
      domain = 'ikZoekBaas'
      site = 'ikZoekBaas'
    } else if (/^([ap]-)?mijndieriszoek[.]/i.test(hostname)) {
      keyword = 'mijndieriszoek'
      domain = 'mijnDierIsZoek'
      site = 'mijnDierIsZoek'
    } else if (/^((www|a|p)[.])?inspectiedienst[.]/i.test(hostname)) {
      keyword = 'inspectiedienst'
      domain = 'inspectiedienst'
      site = 'inspectiedienst'
      style = 'lid'
    }

    // Un-split routes where one route contains multiple paths joined using the '~~' characters,
    // then filter out non-matching routes and remove the domain prefix
    const test = new RegExp(`^/(${keyword}|all)`, 'i')
    routes = routes
      .flatMap((route) =>
        route.path
          .split('~~')
          .filter((path) => test.test(path))
          .map((path, index) => {
            if (index > 0 && route.name) {
              const [name, locale] = route.name.split('___')
              return { ...route, path, name: `${name}-${index}___${locale}` }
            } else {
              return { ...route, path }
            }
          }),
      )
      .map((route) => {
        route = { ...route, path: route.path.replace(test, '') || '/', meta: { ...route.meta, domain, site, style } }
        Object.entries(routeParamOptions).forEach(([param, options]) => {
          if (route.path.includes(`:${param}()`)) {
            route.path = route.path.replace(`:${param}()`, `:${param}(${options.join('|')})`)
          }
        })
        return route
      })

    // Sort the routes
    sortRoutes(routes)

    return routes
  },
} satisfies RouterConfig
